(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("bluebird"), require("globalize"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "bluebird", "globalize", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("bluebird"), require("globalize"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["bluebird"], root["globalize"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "I18nModel", {
  enumerable: true,
  get: function get() {
    return _index.I18nModel;
  }
});

var _index = __webpack_require__(2);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nModel = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _bluebird = _interopRequireDefault(__webpack_require__(4));

var _globalize = _interopRequireDefault(__webpack_require__(5));

var _locale = __webpack_require__(6);

var _resource = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var localeManager = new _locale.LocaleManager();
var dynamicLocaleInstances = [];
/**
 * @this I18nModel
 * @param {String} key localization key
 * @returns {void}
 * @private
 */

function assertReady(key) {
  if (!this.isReady()) {
    var debugInfo = "name-".concat(this.name, ",culture-").concat(this.locale, ",key-").concat(key);
    throw new Error("The resource is not yet ready(".concat(debugInfo, "). Please either call sync APIs only when the promise is fulfilled, or switch to use async APIs."));
  }
}
/**
 * @this I18nModel
 * @param {String} key localization key
 * @returns {Resource} Current synchronous resource
 * @private
 */


function synchronousResource(key) {
  assertReady.call(this, key);
  return this.p$data.value().resource;
}
/**
 * @this I18nModel
 * @returns {Globalize} Current synchronous globalize
 * @private
 */


function synchronousGlobalize() {
  assertReady.call(this);
  return this.p$data.value().globalize;
}
/**
 * If the given object is thenable
 * @param {any} object - The object to be tested
 * @returns {bool} Current synchronous globalize
 * @private
 */


function isThenable(object) {
  return object && _underscore.default.isFunction(object.then);
}
/**
 * @this I18nModel
 * @param {string} locale - the locale used to load data
 * @returns {Promise} Promise of translation resource and globalize
 * @private
 */


function loadData(locale) {
  var _this = this;

  var translationData = this.loadTranslationData(locale);
  var cldrData = this.loadCLDRData(locale);

  if (isThenable(translationData) || isThenable(cldrData)) {
    return _bluebird.default.props({
      locale: locale,
      resource: _bluebird.default.resolve(translationData).then(function (data) {
        return new _resource.Resource({
          data: data,
          failFast: _this.failFast
        });
      }),
      globalize: _bluebird.default.resolve(cldrData).then(function (cldr) {
        return new _globalize.default(cldr);
      })
    });
  }

  return _bluebird.default.resolve({
    locale: locale,
    resource: new _resource.Resource({
      data: translationData,
      failFast: this.failFast
    }),
    globalize: new _globalize.default(cldrData)
  });
}
/* @this I18nModel */


function dateMethodOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      skeleton = _ref.skeleton,
      date = _ref.date,
      time = _ref.time,
      datetime = _ref.datetime,
      raw = _ref.raw,
      _ref$timeZone = _ref.timeZone,
      timeZone = _ref$timeZone === void 0 ? this.timeZone : _ref$timeZone;

  return _underscore.default.pick({
    skeleton: skeleton,
    date: date,
    time: time,
    datetime: datetime,
    raw: raw,
    timeZone: timeZone
  }, Boolean);
}
/* @this I18nModel */


function withSignWrapper(withSign, method) {
  switch (withSign) {
    case 'auto':
      return function (value) {
        return method(value);
      };

    case 'never':
      return function (value) {
        return method(Math.abs(value));
      };

    case 'always':
      {
        var cldr = this.getCldr();
        var minusSign = cldr.main('numbers/symbols-numberSystem-latn/minusSign');
        var plusSign = cldr.main('numbers/symbols-numberSystem-latn/plusSign');
        return function (value) {
          if (value < 0) {
            return method(value);
          } // Same as described in CLDR ticket
          // see: http://unicode.org/cldr/trac/ticket/8732
          // Note: 0 will have no sign


          return method(-value).replace( // only support latn for now
          minusSign, plusSign);
        };
      }

    default:
      throw new RangeError("'withSign' option should be one of 'auto', 'never' or 'always', but being ".concat(withSign));
  }
}
/**
 * Return a function synchronously format a number with given options.
 * @param {string} [withSign=auto] - Show positive/negative sign or not.
 *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
 * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
 * @return {Function} The function formatting number
 * @private
 */


function numberFormatterWithSign(withSign, options) {
  var globalizeFormatter = synchronousGlobalize.call(this).numberFormatter(options); // SignificantDigits related param override IntegerDigits/FractionDigits related param
  // pick Boolean to remove them if they're not passed in

  return withSignWrapper.call(this, withSign, function (value) {
    return globalizeFormatter(value);
  });
}
/**
 * Return a function synchronously format a currency with given options.
 * @param {string} currency - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
 * @param {string} [withSign=auto] - Show positive/negative sign or not.
 *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
 * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
 * @return {Function} The function formatting number
 * @private
 */


function currencyFormatterWithSign(currency) {
  var withSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  var options = arguments.length > 2 ? arguments[2] : undefined;

  if (!currency) {
    return function () {
      return '0';
    };
  }

  var globalizeFormatter = synchronousGlobalize.call(this).currencyFormatter(currency, options); // SignificantDigits related param override IntegerDigits/FractionDigits related param
  // pick Boolean to remove them if they're not passed in

  return withSignWrapper.call(this, withSign, function (value) {
    return globalizeFormatter(value);
  });
}

function currencyFormatterWithSymbol(currency) {
  var withSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
  var withSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var options = arguments.length > 3 ? arguments[3] : undefined;

  if (!currency) {
    return function () {
      return '0';
    };
  }

  if (withSymbol) {
    return currencyFormatterWithSign.call(this, currency, withSign, options);
  }

  var globalizeFormatter = synchronousGlobalize.call(this).currencyToPartsFormatter(currency, options);

  var formatter = function formatter(value) {
    var parts = globalizeFormatter(value);

    var newParts = _underscore.default.map(parts, function (part) {
      if (part.type === 'integer' || part.type === 'group' || part.type === 'decimal' || part.type === 'fraction') {
        return part.value;
      }

      return '';
    });

    var finalValue = newParts.join('');
    return finalValue;
  };

  return withSignWrapper.call(this, withSign, formatter);
}

function withGlobalizeCache(fnName, i18nModel) {
  var realMethod = i18nModel[fnName];

  function createCache() {
    var cache = {};
    cache.size = 0;
    return cache;
  }

  return function wrappedGlobalizeMethod() {
    var cache = i18nModel.parserFormatterCache;

    if (!cache[fnName]) {
      cache[fnName] = createCache();
    }

    var specificMethodCache = cache[fnName];

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var key = JSON.stringify(args);

    if (specificMethodCache[key]) {
      return specificMethodCache[key];
    }
    /* Just a precaution, don't expect cache to grow this large */


    if (specificMethodCache.size > 100) {
      cache[fnName] = createCache();
      specificMethodCache = cache[fnName];
    }

    specificMethodCache[key] = realMethod.apply(this, args);
    specificMethodCache.size += 1;
    return specificMethodCache[key];
  };
}
/**
 * I18n Model.
 */


var I18nModel =
/*#__PURE__*/
function () {
  _createClass(I18nModel, null, [{
    key: "setGlobalLocale",

    /**
     * Set global locale used for all i18n model as default locale.
     * @param {string} locale - should be in format of IETF language tag {@link http://www.langtag.net/}.
     * @returns {Promise.<I18nModel[]>} resolved when all dynamic locale i18n models are ready
     */
    value: function setGlobalLocale(locale) {
      localeManager.setGlobalLocale(locale);
      return _bluebird.default.all(_underscore.default.map(dynamicLocaleInstances, function (instance) {
        return instance.setLocale(locale);
      }));
    }
    /**
     * Load CLDR data for Globalize.js.
     * Helper function which makes Globalize transparent to users.
     * Then user don't need to import it explictly.
     * @param {JSON[]} data - CLDR data.
     * @returns {void}
     */

  }, {
    key: "loadCLDRData",
    value: function loadCLDRData() {
      _globalize.default.load.apply(_globalize.default, arguments);
    }
    /**
     * Load time zone data for Globalize.js.
     * Helper function which makes Globalize transparent to users.
     * Then user don't need to import it explictly.
     * @param {JSON} data - Time zone data.
     * @returns {void}
     */

  }, {
    key: "loadTimeZoneData",
    value: function loadTimeZoneData(data) {
      _globalize.default.loadTimeZone(data);
    }
    /**
     * Sets the default failfast value for every i18nmodel
     *
     * @returns {void}
     * @param {string|bool} failfast  when key missing
     *     true   - i18n throws error and crashes current execution
     *    "SAFE"  - i18n throws error asyncrounously but continues execution
     */

  }, {
    key: "setDefaultFailFast",
    value: function setDefaultFailFast(failfast) {
      I18nModel.defaultFailFast = failfast;
    }
    /**
     * @callback loadCLDRData
     * @param {string} locale - the locale used to load CLDR data
     * @returns {Promise.<CldrJs>|Promise.<string>|CldrJs|string}
     *    The CLDR data or the locale name linked to already loaded CLDR data
     */

    /**
     * @callback loadTranslationData
     * @param {string} locale - the locale used to load translation data
     * @returns {Promise.<Object.<string, string>>|Object.<string, string>}
     *    key value pairs as tranlation data
     */

    /**
     * Create a model.
     * When both options.loadCLDRData and options.loadTranslationData returns raw data instead
     * of Promise, and locale is neither 'current' nor 'dynamic', the model created is surely
     * ready for use synchronously.
     * @param {Object} options - The initialization options
     * @param {string} [options.name] - The name of the i18n package
     * @param {string} [options.locale=current] - The locale of this i18n model; could be a
     *   specific locale (e.g. 'en-us'), 'dynamic' or 'current' (default)
     * @param {string} [options.timeZone] - The default timeZone used by formatDate
     * @param {string} [options.currency] - The default currency used by formatCurrency
     * @param {loadCLDRData} options.loadCLDRData - a function which accepts locale as param and
     *   returns a promise which resolves after coresponding CLDR data loaded, and with value
     *   the CLDR.js instance or the locale name as [Globalize constructor]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/core/constructor.md} requires
     * @param {loadTranslationData} options.loadTranslationData - a function which accepts locale
     *   as param and returns a promise which resolves with a translation data object
     * @param {string|bool} options.failFast - when key missing
     *     true   - i18n throws error and crashes current execution
     *    "SAFE"  - i18n throws error asyncrounously but continues execution
     *
     * @constructs I18nModel
     */

  }]);

  function I18nModel(_ref2) {
    var _this2 = this;

    var name = _ref2.name,
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? 'current' : _ref2$locale,
        timeZone = _ref2.timeZone,
        currency = _ref2.currency,
        loadCLDRData = _ref2.loadCLDRData,
        loadTranslationData = _ref2.loadTranslationData,
        _ref2$failFast = _ref2.failFast,
        failFast = _ref2$failFast === void 0 ? I18nModel.defaultFailFast : _ref2$failFast;

    _classCallCheck(this, I18nModel);

    this.locale = locale;
    this.name = name;
    this.timeZone = timeZone;
    this.currency = currency;
    this.loadCLDRData = loadCLDRData;
    this.loadTranslationData = loadTranslationData;
    this.missingKeys = {};
    this.failFast = failFast;
    this.parserFormatterCache = {};
    /* These methods return parsers and formatters that can be safely cached.
    (they don't have any functions as a parameter). Globalize recommends caching
    parsers and formatters as generating them can be very expensive */

    ['decimalParser', 'percentParser', 'dateFormatter', 'dateToPartsFormatter', 'dateParser'].forEach(function (fnName) {
      _this2[fnName] = withGlobalizeCache(fnName, _this2);
    });

    if (locale === 'dynamic') {
      // If dynamic, reload resource on locale change
      dynamicLocaleInstances.push(this);
    }

    if (locale === 'current' || locale === 'dynamic') {
      // Wait for initial locale to be set and then load the resource
      var p$globalLocale = localeManager.p$globalLocale(); // when global locale is synced ready, make p$data synced ready too

      if (p$globalLocale.isFulfilled()) {
        this.p$data = loadData.call(this, p$globalLocale.value());
      } else {
        this.p$data = localeManager.p$globalLocale().then(function (globalLocale) {
          return loadData.call(_this2, globalLocale);
        });
      }
    } else {
      this.setLocale(locale);
    }
  }
  /**
   * Set locale used for this model, will reuse other data.
   * @param {string} locale - should be in format of IETF language tag {@link http://www.langtag.net/}.
   * @returns {Promise.<I18nModel>} resolved when all resource for this model loaded
   */


  _createClass(I18nModel, [{
    key: "setLocale",
    value: function setLocale(locale) {
      this.p$data = loadData.call(this, locale);
      this.parserFormatterCache = {};
      return this.ready();
    }
    /**
     * Get a promise that resolves to this object when the resource is ready.
     * @return {Promise.<I18nModel>} This object
     */

  }, {
    key: "ready",
    value: function ready() {
      return this.p$data.return(this);
    }
    /**
     * Check whether the resource is ready.
     * @return {boolean} Whether the resource is ready
     */

  }, {
    key: "isReady",
    value: function isReady() {
      return this.p$data.isFulfilled();
    } // Sync API
    // All these methods only work when isReady().
    // If isReady() === false, these methods would throw error.

    /**
     * Synchronously get locale used for this model.
     * @returns {string} locale used for this model.
     */

  }, {
    key: "getLocale",
    value: function getLocale() {
      assertReady.call(this);
      return this.p$data.value().locale;
    }
    /**
     * Synchronously get Cldrjs instance.
     * @return {Cldrjs} The Cldrjs instance.
     * @see [cldr.js - Simple CLDR traverser]{@link https://github.com/rxaviers/cldrjs}
     */

  }, {
    key: "getCldr",
    value: function getCldr() {
      return synchronousGlobalize.call(this).cldr;
    }
    /**
     * Synchronously get first day of week.
     * @param {Object} [options] - options
     * @param {String} [options.alt] - undefined or 'variant'.
     * @return {string} The weekday as first day of week. One of 'mon', 'fri', 'sat', sun'.
     */

  }, {
    key: "getFirstDayOfWeek",
    value: function getFirstDayOfWeek() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          alt = _ref3.alt;

      var cldr = this.getCldr();
      var defaultRegionKey = cldr.attributes.region;
      var key = alt ? "".concat(defaultRegionKey, "-alt-").concat(alt) : defaultRegionKey;
      return cldr.supplemental("weekData/firstDay/".concat(key)) || cldr.supplemental("weekData/firstDay/".concat(defaultRegionKey)) || // 001 means the world
      // see: http://cldr.unicode.org/index/cldr-spec/reasons-for-decisions
      cldr.supplemental('weekData/firstDay/001');
    }
    /**
     * Synchronously get today as CivilDate.
     * Note: for not introducing temporal for now,
     *  this method only returns an object with same structure instead of a real CivilDate.
     * @param {Object} [options] - options
     * @param {String} [options.timeZone] - Time zone name under tz database format.
     * @return {CivilDate} Today as CivilDate.
     * @see [List of tz database time zones]{@link https://en.wikipedia.org/wiki/List_of_tz_database_time_zones}
     */

  }, {
    key: "getToday",
    value: function getToday() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$timeZone = _ref4.timeZone,
          timeZone = _ref4$timeZone === void 0 ? this.timeZone : _ref4$timeZone;

      var _this$formatDateToPar = this.formatDateToParts(new Date(), {
        raw: 'yyyyMMdd',
        timeZone: timeZone
      }),
          _this$formatDateToPar2 = _slicedToArray(_this$formatDateToPar, 3),
          year = _this$formatDateToPar2[0].value,
          month = _this$formatDateToPar2[1].value,
          day = _this$formatDateToPar2[2].value;

      return {
        year: Number(year),
        month: Number(month),
        day: Number(day),
        toString: function toString() {
          return "".concat(year, "-").concat(month, "-").concat(day);
        }
      };
    }
    /**
     * Synchronously get today.
     * This method returns an object with all properties of CivilDate and time-related properties.
     * Note: for not introducing temporal for now,
     *  this method only returns an object which can be operated as CivilDate but not a real CivilDate.
     * @param {Object} [options] - options
     * @param {String} [options.timeZone] - Time zone name under tz database format.
     * @return {CivilDate} Today as CivilDate.
     * @see [List of tz database time zones]{@link https://en.wikipedia.org/wiki/List_of_tz_database_time_zones}
     */

  }, {
    key: "getTodayTiming",
    value: function getTodayTiming() {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$timeZone = _ref5.timeZone,
          timeZone = _ref5$timeZone === void 0 ? this.timeZone : _ref5$timeZone;

      var _this$formatDateToPar3 = this.formatDateToParts(new Date(), {
        raw: 'yyyyMMddHHmmss',
        timeZone: timeZone
      }),
          _this$formatDateToPar4 = _slicedToArray(_this$formatDateToPar3, 6),
          year = _this$formatDateToPar4[0].value,
          month = _this$formatDateToPar4[1].value,
          day = _this$formatDateToPar4[2].value,
          hour = _this$formatDateToPar4[3].value,
          minute = _this$formatDateToPar4[4].value,
          second = _this$formatDateToPar4[5].value;

      return {
        year: Number(year),
        month: Number(month),
        day: Number(day),
        hour: Number(hour),
        minute: Number(minute),
        second: Number(second),
        toString: function toString() {
          return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
        }
      };
    }
    /**
     * Synchronously get and evaluate a localized string template (or the string as-is if it's
     *   not a template).
     * If key not found, "undefined" will be returned, client code should check this for themselves.
     * @param {string} key - The key of the string resource
     * @param {Object} [model] - The model for the string template (if needed)
     * @return {string} The template evaluation result
     */

  }, {
    key: "getString",
    value: function getString(key) {
      var _synchronousResource$;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var str = (_synchronousResource$ = synchronousResource.call(this, key)).getString.apply(_synchronousResource$, [key].concat(args));

      if (_underscore.default.isUndefined(str)) {
        // key is not surrounded by fixture _TL_
        this.missingKeys[key] = true;

        if (this.failFast) {
          try {
            throw new RangeError("i18n.getString: key is missing _TL_ fixture - \"".concat(key, "\""));
          } catch (error) {
            if (this.failFast !== 'SAFE') {
              throw error;
            } else {
              _underscore.default.defer(function () {
                throw error;
              });

              str = key;
            }
          }
        }
      }

      return str;
    }
    /**
     * Synchronously get all the localized string data object passed to Resource from onload.
     * @return {Object} An object of i18n key-localized value pair
     */

  }, {
    key: "getData",
    value: function getData() {
      return _objectSpread({}, synchronousResource.call(this, 'getData').data);
    }
    /**
     * Synchronously get quarter's translation.
     * @param {Number} quarter - An integer from 1 to 4 which matches with 1st to 4th quarter
     * @param {Object} [options] - options
     * @param {String} [options.style=wide] - 'abbreviated', 'narrow' or 'wide'
     * @return {String} The quarter's translation
     */

  }, {
    key: "getQuarter",
    value: function getQuarter(quarter) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$style = _ref6.style,
          style = _ref6$style === void 0 ? 'wide' : _ref6$style;

      return this.getCldr().main("dates/calendars/gregorian/quarters/stand-alone/".concat(style, "/").concat(quarter));
    }
    /**
     * Synchronously get month's translation.
     * @param {Number} month - An integer from 1 to 12 which matches with January to December
     * @param {Object} [options] - options
     * @param {String} [options.style=wide] - 'abbreviated', 'narrow' or 'wide'
     * @return {String} The month's translation
     */

  }, {
    key: "getMonth",
    value: function getMonth(month) {
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref7$style = _ref7.style,
          style = _ref7$style === void 0 ? 'wide' : _ref7$style;

      return this.getCldr().main("dates/calendars/gregorian/months/stand-alone/".concat(style, "/").concat(month));
    }
    /**
     * Synchronously get day's translation.
     * @param {String} day - 'sun', 'mon', 'tue', 'wed', 'thu', 'fri' or 'sat'
     * @param {Object} [options] - options
     * @param {String} [options.style=wide] - 'abbreviated', 'narrow', 'short' or 'wide'
     * @return {String} The day's translation
     */

  }, {
    key: "getDay",
    value: function getDay(day) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref8$style = _ref8.style,
          style = _ref8$style === void 0 ? 'wide' : _ref8$style;

      return this.getCldr().main("dates/calendars/gregorian/days/stand-alone/".concat(style, "/").concat(day));
    }
    /**
     * Alias of [getDay]{@link I18nModel#getDay}
     * @param {String} dayOfWeek - 'sun', 'mon', 'tue', 'wed', 'thu', 'fri' or 'sat'
     * @param {Object} [options] - options
     * @param {String} [options.style=wide] - 'abbreviated', 'narrow', 'short' or 'wide'
     * @return {String} The day's translation
     */

  }, {
    key: "getDayOfWeek",
    value: function getDayOfWeek(dayOfWeek, options) {
      return this.getDay(dayOfWeek, options);
    }
    /**
     * Synchronously get currency's display name.
     * @param {String} [currency=this.currency] - currency code under [ISO 4217]{@link https://www.iso.org/iso-4217-currency-codes.html}
     * @return {String} The currency's display name
     */

  }, {
    key: "getCurrency",
    value: function getCurrency() {
      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currency;
      return this.getCldr().main("numbers/currencies/".concat(currency, "/displayName"));
    }
    /**
     * Synchronously get currency's symbol.
     * @param {String} [currency=this.currency] - currency code under [ISO 4217]{@link https://www.iso.org/iso-4217-currency-codes.html}
     * @param {Object} [options] - options
     * @param {String} [options.alt] - undefined, 'narrow' or 'variant'.
     *  'narrow' or 'variant' won't exist for sure.
     *   when the data missing, it will fallback to the default symbol.
     *   As an example:
     *     for TRY (Turkish Lira), default symbol is 'TRY', narrow alt is '₺', variant alt is 'TL'
     * @return {String} The currency's symbol
     */

  }, {
    key: "getCurrencySymbol",
    value: function getCurrencySymbol() {
      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currency;

      var _ref9 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          alt = _ref9.alt;

      var defaultSymbolKey = 'symbol';
      var key = alt ? "symbol-alt-".concat(alt) : defaultSymbolKey;
      return this.getCldr().main("numbers/currencies/".concat(currency, "/").concat(key)) || this.getCldr().main("numbers/currencies/".concat(currency, "/").concat(defaultSymbolKey));
    }
    /**
     * The object contains all patterns
     * @typedef {Object} Patterns
     * @property {string} [full] The full format pattern
     * @property {string} [long] The long format pattern
     * @property {string} [medium] The medium format pattern
     * @property {string} [short] The short format pattern
     */

    /**
     * The DateFormats contains date/dateTime/time format patterns
     * @typedef {Object} DateFormats
     * @property {string} [default] The default date format pattern
     * @property {Patterns} [date] The date patterns
     * @property {Patterns} [dateTime] The dateTime patterns
     * @property {Patterns} [time] The time patterns
     */

    /**
     * Synchronously get date format patterns for user's culture
     * @return {DateFormats} The date format patterns object
     */

  }, {
    key: "getDateFormats",
    value: function getDateFormats() {
      var calendar = this.getCldr().main('dates/calendars/gregorian');
      var defaultProperties = ['full', 'long', 'medium', 'short'];
      return {
        default: calendar.dateTimeFormats.availableFormats.yMd,
        // Globalize will use yMd as the default date format pattern. https://github.com/globalizejs/globalize/blob/d5e98d1e3047ac722cce5817f8168268dd22ddf4/src/date.js#L136
        date: _underscore.default.pick(calendar.dateFormats, defaultProperties),
        dateTime: _underscore.default.pick(calendar.dateTimeFormats, defaultProperties),
        time: _underscore.default.pick(calendar.timeFormats, defaultProperties)
      };
    }
    /**
     * Synchronously format decimal number with given options.
     * @param {number} number - The number to be formatted
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {string} The formatted decimal number
     */

  }, {
    key: "formatDecimal",
    value: function formatDecimal(number, options) {
      return this.decimalFormatter(options)(number);
    }
    /**
     * Return a function synchronously format decimal number with given options.
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {Function} The function formatting decimal number
     */

  }, {
    key: "decimalFormatter",
    value: function decimalFormatter() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          minimumIntegerDigits = _ref10.minimumIntegerDigits,
          minimumFractionDigits = _ref10.minimumFractionDigits,
          maximumFractionDigits = _ref10.maximumFractionDigits,
          minimumSignificantDigits = _ref10.minimumSignificantDigits,
          maximumSignificantDigits = _ref10.maximumSignificantDigits,
          round = _ref10.round,
          useGrouping = _ref10.useGrouping,
          compact = _ref10.compact,
          _ref10$withSign = _ref10.withSign,
          withSign = _ref10$withSign === void 0 ? 'auto' : _ref10$withSign;

      return numberFormatterWithSign.call(this, withSign, {
        style: 'decimal',
        minimumIntegerDigits: minimumIntegerDigits,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        minimumSignificantDigits: minimumSignificantDigits,
        maximumSignificantDigits: maximumSignificantDigits,
        round: round,
        useGrouping: useGrouping,
        compact: compact
      });
    }
    /**
     * Synchronously format decimal number to fixed-point as toFixed(digits) with given options.
     * This method is only a shortcut built on top of formatDecimal, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {number} number - The number to be formatted
     * @param {Object} [options] - options
     * @param {number} [options.digits=2] - The number of fraction digits
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {string} The formatted decimal number
     */

  }, {
    key: "formatDecimalToFixed",
    value: function formatDecimalToFixed(number, options) {
      return this.decimalToFixedFormatter(options)(number);
    }
    /**
     * Return a function synchronously format decimal number to fixed-point as toFixed(digits).
     * This method is only a shortcut built on top of formatDecimal, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {Object} [options] - options
     * @param {number} [options.digits=2] - The number of fraction digits
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {Function} The function formatting decimal number
     */

  }, {
    key: "decimalToFixedFormatter",
    value: function decimalToFixedFormatter() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref11$digits = _ref11.digits,
          digits = _ref11$digits === void 0 ? 2 : _ref11$digits,
          round = _ref11.round,
          useGrouping = _ref11.useGrouping,
          compact = _ref11.compact,
          _ref11$withSign = _ref11.withSign,
          withSign = _ref11$withSign === void 0 ? 'auto' : _ref11$withSign;

      return this.decimalFormatter({
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
        round: round,
        useGrouping: useGrouping,
        compact: compact,
        withSign: withSign
      });
    }
    /**
     * Synchronously format decimal number to integer as toFixed(0) with given options.
     * This method is only a shortcut built on top of formatDecimal, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {number} number - The number to be formatted
     * @param {Object} [options] - options
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {string} The formatted decimal number
     */

  }, {
    key: "formatDecimalToInteger",
    value: function formatDecimalToInteger(number, options) {
      return this.decimalToIntegerFormatter(options)(number);
    }
    /**
     * Return a function synchronously format decimal number to integer as toFixed(0).
     * This method is only a shortcut built on top of formatDecimal, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {Object} [options] - options
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {Function} The function formatting decimal number
     */

  }, {
    key: "decimalToIntegerFormatter",
    value: function decimalToIntegerFormatter() {
      var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          round = _ref12.round,
          useGrouping = _ref12.useGrouping,
          compact = _ref12.compact,
          _ref12$withSign = _ref12.withSign,
          withSign = _ref12$withSign === void 0 ? 'auto' : _ref12$withSign;

      return this.decimalToFixedFormatter({
        digits: 0,
        round: round,
        useGrouping: useGrouping,
        compact: compact,
        withSign: withSign
      });
    }
    /**
     * Synchronously parse decimal number.
     * @param {string} value - The number string to be parsed
     * @return {string} The parsed decimal number, NaN is value is invalid
     */

  }, {
    key: "parseDecimal",
    value: function parseDecimal(value) {
      return this.decimalParser()(value);
    }
    /**
     * Return a function synchronously parse decimal number.
     * @return {Function} The function parsing decimal number
     */

  }, {
    key: "decimalParser",
    value: function decimalParser() {
      return synchronousGlobalize.call(this).numberParser({
        style: 'decimal'
      });
    }
    /**
     * Synchronously validate decimal number, a simple wrapper of parseDecimal.
     * @param {string} value - The number string to be validate
     * @return {boolean} If value is string and valid.
     *   Note: number is not valid too, as this method is for strings.
     */

  }, {
    key: "isValidDecimal",
    value: function isValidDecimal(value) {
      return this.decimalValidator()(value);
    }
    /**
     * Return a function synchronously validate decimal number.
     * @return {Function} The function validating decimal number
     */

  }, {
    key: "decimalValidator",
    value: function decimalValidator() {
      var parser = this.decimalParser();
      return function (value) {
        return _underscore.default.isString(value) && !_underscore.default.isNaN(parser(value));
      };
    }
    /**
     * Synchronously format percent number with given options.
     * @param {number} number - The number to be formatted
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {string} The formatted percent number
     */

  }, {
    key: "formatPercent",
    value: function formatPercent(number, options) {
      return this.percentFormatter(options)(number);
    }
    /**
     * Return a function synchronously format percent number with given options.
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {Function} The function formatting percent number
     */

  }, {
    key: "percentFormatter",
    value: function percentFormatter() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          minimumIntegerDigits = _ref13.minimumIntegerDigits,
          minimumFractionDigits = _ref13.minimumFractionDigits,
          maximumFractionDigits = _ref13.maximumFractionDigits,
          minimumSignificantDigits = _ref13.minimumSignificantDigits,
          maximumSignificantDigits = _ref13.maximumSignificantDigits,
          round = _ref13.round,
          useGrouping = _ref13.useGrouping,
          compact = _ref13.compact,
          _ref13$withSign = _ref13.withSign,
          withSign = _ref13$withSign === void 0 ? 'auto' : _ref13$withSign;

      return numberFormatterWithSign.call(this, withSign, {
        style: 'percent',
        minimumIntegerDigits: minimumIntegerDigits,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        minimumSignificantDigits: minimumSignificantDigits,
        maximumSignificantDigits: maximumSignificantDigits,
        round: round,
        useGrouping: useGrouping,
        compact: compact
      });
    }
    /**
     * Synchronously format percent number to fixed-point as toFixed(digits) with given options.
     * This method is only a shortcut built on top of formatPercent, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {number} number - The number to be formatted
     * @param {Object} [options] - options
     * @param {number} [options.digits=0] - The number of fraction digits
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {string} The formatted percent number
     */

  }, {
    key: "formatPercentToFixed",
    value: function formatPercentToFixed(number, options) {
      return this.percentToFixedFormatter(options)(number);
    }
    /**
     * Return a function synchronously format percent number to fixed-point as toFixed(digits).
     * This method is only a shortcut built on top of percentFormatter, it isn't in i18n interface
     *   and shouldn't be used by shared components.
     * @see [Number.prototype.toFixed()]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed}
     * @param {Object} [options] - options
     * @param {number} [options.digits=0] - The number of fraction digits
     * @param {boolean} [options.round] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {boolean} [options.useGrouping] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/number/number-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @return {Function} The function formatting percent number
     */

  }, {
    key: "percentToFixedFormatter",
    value: function percentToFixedFormatter() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref14$digits = _ref14.digits,
          digits = _ref14$digits === void 0 ? 0 : _ref14$digits,
          round = _ref14.round,
          useGrouping = _ref14.useGrouping,
          compact = _ref14.compact,
          _ref14$withSign = _ref14.withSign,
          withSign = _ref14$withSign === void 0 ? 'auto' : _ref14$withSign;

      return this.percentFormatter({
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
        round: round,
        useGrouping: useGrouping,
        compact: compact,
        withSign: withSign
      });
    }
    /**
     * Synchronously parse percent number.
     * @param {string} value - The number string to be parsed
     * @return {string} The parsed percent number, NaN when value is invalid
     */

  }, {
    key: "parsePercent",
    value: function parsePercent(value) {
      return this.percentParser()(value);
    }
    /**
     * Return a function synchronously parse percent number.
     * @return {Function} The function parsing percent number
     */

  }, {
    key: "percentParser",
    value: function percentParser() {
      return synchronousGlobalize.call(this).numberParser({
        style: 'percent'
      });
    }
    /**
     * Synchronously validate percent number, a simple wrapper of parsePercent.
     * @param {string} value - The number string to be validate
     * @return {boolean} If value is string and valid
     */

  }, {
    key: "isValidPercent",
    value: function isValidPercent(value) {
      return this.percentValidator()(value);
    }
    /**
     * Return a function synchronously validate percent number.
     * @return {Function} The function validating percent number
     */

  }, {
    key: "percentValidator",
    value: function percentValidator() {
      var parser = this.percentParser();
      return function (value) {
        return _underscore.default.isString(value) && !_underscore.default.isNaN(parser(value));
      };
    }
    /**
     * Synchronously format currency with given options.
     * @param {number} number - The number to be formatted
     * @param {string} currency - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @param {string} [options.withSymbol=true] - Show currency symbol or not.
     * @return {string} The formatted currency
     */

  }, {
    key: "formatCurrency",
    value: function formatCurrency(number) {
      var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currency;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      return this.currencyFormatter(currency, options)(number);
    }
    /**
     * Return a function synchronously format currency with given options.
     * @param {string} currency - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/currency/currency-formatter.md}
     * @param {string} [options.withSign=auto] - Show positive/negative sign or not.
     *    Could be 'always', 'auto' or 'never'. 'auto' means show sign for negative but not positive.
     * @param {string} [options.withSymbol=true] - Show currency symbol or not.
     * @return {Function} The function formatting currency
     */

  }, {
    key: "currencyFormatter",
    value: function currencyFormatter() {
      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currency;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Didn't do argument destructuring for options,
      // due to currencyFormatter dose not format floating point correctly
      // with some of the options undefined.
      var withSign = options.withSign,
          withSymbol = options.withSymbol;
      return currencyFormatterWithSymbol.call(this, currency, withSign, withSymbol, _underscore.default.omit(options, 'withSign', 'withSymbol'));
    }
    /**
     * Synchronously format date with given options.
     * @param {Date} value - The date to be formatted
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {string} The formatted date
     */

  }, {
    key: "formatDate",
    value: function formatDate(value, options) {
      return this.dateFormatter(options)(value);
    }
    /**
     * Return a function synchronously format date with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {Function} The function formatting date
     */

  }, {
    key: "dateFormatter",
    value: function dateFormatter(options) {
      return synchronousGlobalize.call(this).dateFormatter(dateMethodOptions.call(this, options));
    }
    /**
     * Synchronously format date into parts tokens with given options.
     * @param {Date} value - The date to be formatted
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {Object[]} The formatted date parts
     */

  }, {
    key: "formatDateToParts",
    value: function formatDateToParts(value, options) {
      return this.dateToPartsFormatter(options)(value);
    }
    /**
     * Return a function synchronously format date into parts tokens with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {Function} The function formatting date to parts
     */

  }, {
    key: "dateToPartsFormatter",
    value: function dateToPartsFormatter(options) {
      return synchronousGlobalize.call(this).dateToPartsFormatter(dateMethodOptions.call(this, options));
    }
    /**
     * Synchronously parse date.
     * @param {string} value - The date string to be parsed
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-parser.md}
     * @return {string} The parsed date, null when value is invalid
     */

  }, {
    key: "parseDate",
    value: function parseDate(value, options) {
      return _underscore.default.isString(value) ? this.dateParser(options)(value) : null;
    }
    /**
     * Return a function synchronously parse date with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {Function} The function parsing date
     */

  }, {
    key: "dateParser",
    value: function dateParser(options) {
      return synchronousGlobalize.call(this).dateParser(dateMethodOptions.call(this, options));
    }
    /**
     * Synchronously validate date, a simple wrapper of parseDate.
     * @param {string} value - The date string to be validate
     * @param {Object} [options] - Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-parser.md}
     * @return {boolean} If value is string and valid
     */

  }, {
    key: "isValidDate",
    value: function isValidDate(value, options) {
      return this.dateValidator(options)(value);
    }
    /**
     * Return a function synchronously validate date with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     * @return {Function} The function validating date
     */

  }, {
    key: "dateValidator",
    value: function dateValidator(options) {
      var parser = this.dateParser(options);
      return function (value) {
        return _underscore.default.isString(value) && !_underscore.default.isNull(parser(value));
      };
    }
    /**
     * Synchronously format civil date to localized string.
     * @param {CivilDate} civilDate - The civil date to be formatted
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     *  except for 'timeZone', time', and 'datetime'.
     *  As CivilDate doesn't have timeZone/time infomation.
     * @return {string} The formatted civil date
     * @see [Temporal Proposal]{@link https://github.com/tc39/proposal-temporal}
     */

  }, {
    key: "formatCivilDate",
    value: function formatCivilDate(civilDate, options) {
      return this.civilDateFormatter(options)(civilDate);
    }
    /**
     * Return a function synchronously format civil date into string with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     *  except for 'timeZone', time', and 'datetime'.
     *  As CivilDate doesn't have timeZone/time infomation.
     * @return {Function} The function formatting civil date to string
     * @see [Temporal Proposal]{@link https://github.com/tc39/proposal-temporal}
     */

  }, {
    key: "civilDateFormatter",
    value: function civilDateFormatter(options) {
      var dateFormatter = this.dateFormatter(_underscore.default.defaults({
        // we create a date under machine time zone from civilDate
        timeZone: null
      }, _underscore.default.omit(options, 'datetime', 'time')));
      return function (civilDate) {
        return dateFormatter(new Date(civilDate.year, civilDate.month - 1, civilDate.day));
      };
    }
    /**
     * Synchronously parse civil date.
     * @param {string} value - The date string to be parsed
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     *  except for 'timeZone', time', and 'datetime'.
     *  As CivilDate doesn't have timeZone/time infomation.
     * @return {string} The parsed civil date, null when value is invalid
     * @see [Temporal Proposal]{@link https://github.com/tc39/proposal-temporal}
     */

  }, {
    key: "parseCivilDate",
    value: function parseCivilDate(value, options) {
      return this.civilDateParser(options)(value);
    }
    /**
     * Return a function synchronously parse civil date with given options.
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md}
     *  except for 'timeZone', time', and 'datetime'.
     *  As CivilDate doesn't have timeZone/time infomation.
     * @return {Function} The function parsing civil date
     * @see [Temporal Proposal]{@link https://github.com/tc39/proposal-temporal}
     */

  }, {
    key: "civilDateParser",
    value: function civilDateParser(options) {
      var dateParser = this.dateParser(_underscore.default.defaults({
        // we create a date under machine time zone from civilDate
        timeZone: 'UTC'
      }, _underscore.default.omit(options, 'datetime', 'time')));
      return function (value) {
        var date = dateParser(value); // for now, we don't want introduce temporal as dependency of this package

        return _underscore.default.isDate(date) ? {
          year: date.getUTCFullYear(),
          month: date.getUTCMonth() + 1,
          day: date.getUTCDate(),
          toString: function toString() {
            return date.toISOString().substr(0, 10);
          }
        } : null;
      };
    }
    /**
     * Synchronously format unit with given options.
     * @param {number} value - The number to be formatted
     * @param {string} unit - The unit to be formatted
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/unit/unit-formatter.md}
     * @return {string} The formatted unit
     */

  }, {
    key: "formatUnit",
    value: function formatUnit(value, unit, options) {
      return this.unitFormatter(unit, options)(value);
    }
    /**
     * Return a function synchronously format unit with given options.
     * @param {string} unit - The unit to be formatted
     * @param {Object} [options] Same options as [Globalize.js]{@link https://github.com/globalizejs/globalize/blob/master/doc/api/unit/unit-formatter.md}
     * @return {Function} The function formatting unit
     */

  }, {
    key: "unitFormatter",
    value: function unitFormatter(unit) {
      var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          form = _ref15.form,
          _ref15$numberFormatte = _ref15.numberFormatter,
          numberFormatter = _ref15$numberFormatte === void 0 ? this.decimalFormatter() : _ref15$numberFormatte;

      return synchronousGlobalize.call(this).unitFormatter(unit, {
        form: form,
        numberFormatter: numberFormatter
      });
    }
    /**
     * Synchronously format list with given options.
     * @param {string[]} list - The list to be formatted
     * @param {Object} [options] Same options as [Intl.ListFormat stage 2 proposal]{@link https://github.com/zbraniecki/proposal-intl-list-format}
     * @param {Object} [options.style=regular] Could be one of "regular", "regular-long",
     *   "regular-short", "unit", "unit-long", "unit-short", "unit-narrow"
     * @return {string} The formatted list
     */

  }, {
    key: "formatList",
    value: function formatList(list, options) {
      return this.listFormatter(options)(list);
    }
    /**
     * Return a function synchronously format list with given options.
     * @param {Object} [options] Same options as [Intl.ListFormat stage 2 proposal]{@link https://github.com/zbraniecki/proposal-intl-list-format}
     * @param {Object} [options.style=regular] Could be one of "regular", "regular-long",
     *   "regular-short", "unit", "unit-long", "unit-short", "unit-narrow"
     * @return {Function} The function formatting list
     */

  }, {
    key: "listFormatter",
    value: function listFormatter() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref16$style = _ref16.style,
          style = _ref16$style === void 0 ? 'regular' : _ref16$style;

      var _style$split = style.split('-'),
          _style$split2 = _slicedToArray(_style$split, 2),
          type = _style$split2[0],
          variant = _style$split2[1];

      var cldr = this.getCldr();

      var cldrTypeName = _underscore.default.compact([type === 'regular' ? 'standard' : type, variant === 'long' ? null : variant]).join('-');

      var listPattern = cldr.main("listPatterns/listPattern-type-".concat(cldrTypeName));

      var template = function template(pattern) {
        return function (_ref17) {
          var _ref18 = _slicedToArray(_ref17, 2),
              first = _ref18[0],
              second = _ref18[1];

          return pattern.replace('{0}', first).replace('{1}', second);
        };
      };

      var twoTemplate = template(listPattern['2']);
      var middleTemplate = template(listPattern.middle);
      var startTemplate = template(listPattern.start);
      var endTemplate = template(listPattern.end);
      return function (list) {
        var size = _underscore.default.size(list);

        if (size === 0) {
          return '';
        } else if (size === 1) {
          return list[0];
        }

        if (size === 2) {
          return twoTemplate(list);
        }

        var _list = _toArray(list),
            first = _list[0],
            second = _list[1],
            rest = _list.slice(2);

        var middle = _underscore.default.reduce(_underscore.default.initial(rest), function (memo, item) {
          return middleTemplate([memo, item]);
        }, second);

        return startTemplate([first, endTemplate([middle, _underscore.default.last(list)])]);
      };
    } // Async API

    /**
     * Asynchronously get and evaluate a localized string template (or the string as-is if it's
     *   not a template).
     * @param {string} key - The key of the string resource
     * @param {Object} [model] - The model for the string template (if needed)
     * @return {Promise.<string>} A promise that resolves to the template evaluation result
     */

  }, {
    key: "fetchString",
    value: function fetchString(key) {
      var _this3 = this;

      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.p$data.then(function (_ref19) {
        var resource = _ref19.resource;
        var str = resource.getString.apply(resource, [key].concat(args));

        if (!str) {
          _this3.missingKeys[key] = true;
        }

        return str;
      });
    }
    /**
     * Asynchronously get locale used for this model.
     * @returns {Promise.<string>} locale used for this model.
     */

  }, {
    key: "fetchLocale",
    value: function fetchLocale() {
      return this.p$data.then(function (data) {
        return data.locale;
      });
    }
  }]);

  return I18nModel;
}();

exports.I18nModel = I18nModel;

_defineProperty(I18nModel, "defaultFailFast", false);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleManager = void 0;

var _bluebird = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A helper to handle set/get global locale asynchronously.
 * @private
 */
var LocaleManager =
/*#__PURE__*/
function () {
  function LocaleManager() {
    var _this = this;

    _classCallCheck(this, LocaleManager);

    this.p$global = new _bluebird.default(function (resolve) {
      _this.resolveGlobalLocale = resolve;
    });
  }
  /**
   * Get global locale promise.
   * @returns {Promise.<string>} promise of global locale
   * @private
   */


  _createClass(LocaleManager, [{
    key: "p$globalLocale",
    value: function p$globalLocale() {
      return this.p$global;
    }
    /**
     * Set global locale.
     * @param {string} locale - global locale to set.
     * @returns {Promise.<string>} promise of global locale
     * @private
     */

  }, {
    key: "setGlobalLocale",
    value: function setGlobalLocale(locale) {
      if (this.p$global.isFulfilled()) {
        // has been inited
        this.p$global = _bluebird.default.resolve(locale);
      } else {
        // first init
        this.resolveGlobalLocale(locale);
      }

      return this.p$globalLocale();
    }
  }]);

  return LocaleManager;
}();

exports.LocaleManager = LocaleManager;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Resource = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var putil = _interopRequireWildcard(__webpack_require__(8));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Translation resource.
 * @private
 */
var Resource =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of Resource.
   * @param {Object} options - options
   * @param {Object.<string, string>} data - key -> translation pairs.
   * @param {string|bool} failFast - when got errors
   *    "SAFE"  - ignore errors and try to recover by using keys
   *     else   - throw errors and crash current execution
   * @constructs Resource
   * @private
   */
  function Resource(_ref) {
    var data = _ref.data,
        failFast = _ref.failFast;

    _classCallCheck(this, Resource);

    if (!_underscore.default.isObject(data)) {
      throw new Error('Localization data must be an Object');
    }

    this.data = data;
    this.failFast = failFast;
  }
  /**
   * Get translation of given key.
   * When translation is Mustache.js-style template string, model will be filled in.
   * @param {string} key - key of the message translated.
   * @param {Object.<string, string>} [model] - model to be filled into the template string.
   * @param {Function} [preprocess] - Function to use on the template before running curlyTemplate.
   * @returns {string} the translation.
   * @private
   */


  _createClass(Resource, [{
    key: "getString",
    value: function getString(key, model) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$preprocess = _ref2.preprocess,
          preprocess = _ref2$preprocess === void 0 ? _underscore.default.identity : _ref2$preprocess;

      if (!_underscore.default.isString(key)) {
        throw new Error('Localization key must be a String');
      }

      var ret = putil.get(this.data, key);

      if (_underscore.default.isNull(ret)) {
        // translation is not ready, use English text instead
        ret = key;
      }

      if (ret) {
        try {
          ret = preprocess(ret);
        } catch (ex) {
          if (this.failFast === 'SAFE') {
            // maybe there are some errors in the translated strings, try to recover by using the key
            ret = preprocess(key);
          } else {
            throw ex;
          }
        }

        if (!_underscore.default.isString(ret)) {
          throw new Error("Preprocess function must return a String. ".concat(key));
        }

        if (model) {
          try {
            var compiled = putil.curlyTemplate(ret);
            ret = compiled(model);
          } catch (ex) {
            if (this.failFast === 'SAFE') {
              // maybe there are some errors in the translated strings, try to recover by using the key
              var _compiled = putil.curlyTemplate(key);

              ret = _compiled(model);
            } else {
              throw ex;
            }
          }
        }
      }

      return ret;
    }
  }]);

  return Resource;
}();

exports.Resource = Resource;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })
/******/ ]);
});
